import { useGetConstellationsResultQuery } from 'api/ConstellationResultEndPoints';
import dayjs from 'dayjs';
import { ConfigContent, UsageLog } from 'shared/model/usageLog.model';
import { DATE_TIME_FORMAT, TIME_FORMAT } from 'utils/date-utils';

type Props = {
  stat: UsageLog;
  sameDay: boolean;
};

const UserStatConfig = ({ stat, sameDay }: Props) => {
  const format = sameDay ? TIME_FORMAT : DATE_TIME_FORMAT;
  const date = dayjs(stat.date).format(format);

  const content = stat.content as ConfigContent;

  const { data, isLoading } = useGetConstellationsResultQuery({
    id: content.resultId,
    filter: {
      include: ['constellationConfiguration'],
    },
  });

  if (!data) {
    return null;
  }

  const constellationName = data.constellationConfiguration?.name ?? '';

  return (
    <tr>
      <td className="text-right">{date}</td>
      <td>Constellation</td>
      <td className="user-stat-content">{constellationName}</td>
    </tr>
  );
};

export default UserStatConfig;
